"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ChipItem", {
  enumerable: true,
  get: function get() {
    return _ChipItem["default"];
  }
});
var _ChipItem = _interopRequireDefault(require("./ChipItem"));